import { Link } from 'react-router-dom';
import type { CastMember } from '@/mocks/siteData';

interface CastCardProps {
  member: CastMember;
}

export default function CastCard({ member }: CastCardProps) {
  return (
    <Link
      to={`/detail/cast/${member.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-400 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={member.avatar}
          alt={`${member.name} 饰演 ${member.role}`}
          title={`${member.name} - 善良的小姨子角色详情`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/80 to-transparent p-3">
          <p className="text-background-50 text-xs line-clamp-1">{member.role}</p>
        </div>
      </div>
      <div className="p-3.5">
        <h3 className="font-heading font-semibold text-foreground-950 text-base group-hover:text-primary-700 transition-colors">
          {member.name}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          饰 {member.role.split(' · ')[0]}
        </p>
      </div>
    </Link>
  );
}